import { configureStore } from "@reduxjs/toolkit";
import adminSlice from "../slices/AdminSlice";
import currentPageSlice from "../slices/currentPageSlice";
// import logoutSlice from "../slices/LogoutSlice";
import sideBarSlice from "../slices/SidebarSlice";
import pageSlice from "../slices/pageSlice";
export const store = configureStore({
  reducer: {
    adminSlice,
    // logoutSlice,
    pageSlice,
    sideBarSlice,
    currentPageSlice,
  },
});
